import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseSummaryStudyCategoryProgressClasses } from '@/api/responses/manage/summaryStudyCategoryProgressClasses'

export namespace SummaryStudyCategoryProgressClassesApi {
  /**
   * クラス別通常学習進捗平均一覧取得API
   *
   * @param branchId 教室ID
   * @param courseId コースID
   * @param studyCategoryId 教材ID
   * @returns クラス別平均一覧
   */
  export async function getSummary(
    branchId: number,
    courseId: number,
    studyCategoryId: number
  ): Promise<ApiResponseSummaryStudyCategoryProgressClasses> {
    const params = {
      branchId: branchId,
      courseId: courseId,
      studyCategoryId: studyCategoryId,
    }
    return await ApiBase.get('/manage/summaryProgress/classes', params)
  }
}
